import React from "react";
import "./LoadingScreen.scss";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-container scale-in">
        <div className="spinner-container">
          <div className="spinner-outer"></div>
        </div>
        {/* <h2 className="loading-title fade-in">Loading Community</h2>
        <p className="loading-text fade-in">Please wait while we prepare your experience</p> */}
      </div>
    </div>
  );
};

export default LoadingScreen;
